import { GET_ACCOUNT_BANK_ACCOUNTS_SUCCESS } from 'stash/actions/api/bankAccount';
import type { BankAccount } from 'stash/components/bank-link/types';

type BankAccountAction = {
	type: string;
	response?: {
		bank_account?: BANK_ACCOUNT;
	};
};

export type BANK_ACCOUNT = {
	id: number;
	public_id?: string;
	bank_name: string;
	account_name: string;
	masked_account_number: string;
	account_type: string;
	approval_method: string;
	aasm_state: string;
	is_cancelable: boolean;
	is_changeable: boolean;
	is_convertible: boolean;
	funding_source_provider_id: string;
};

function bankAccountReducer(
	state: BankAccount | Record<string, never> = {},
	action: BankAccountAction
) {
	switch (action.type) {
		case GET_ACCOUNT_BANK_ACCOUNTS_SUCCESS:
			return action.response?.bank_account ?? state;
		default:
			return state;
	}
}

export default bankAccountReducer;
